const LocationMilestone = {
  validHeader: {
    'Indent Id': 'indent_no',
    'LR Number': 'lr_number',
    'Source Ref ID': 'source_reference_id',
    'Destination Ref Id': 'destination_reference_id',
    'Material Division': 'material_division',
    'Date and Time (YYYY-MM-DD hh:mm:ss)': 'date_time',
    'Current Status': 'status',
    'Transit location': 'transit_location',
    'Location update': 'location_update',
  },
  validStatus: {
    TRUCK_IN: 'TRUCK_IN',
    TRUCK_OUT: 'TRUCK_OUT',
    IN_TRANSIT: 'IN_TRANSIT',
    CONSIGNMENT_REACHED: 'CONSIGNMENT_REACHED',
    CONSIGNMENT_RELEASE: 'CONSIGNMENT_RELEASE',
  },
  maximumAllowLineItems: 2000,
  exportLimit: 500,
};

module.exports = { LocationMilestone };
